import { render } from "./SimpleStudentCard.vue?vue&type=template&id=5e3d7654&scoped=true"
import script from "./SimpleStudentCard.vue?vue&type=script&lang=js"
export * from "./SimpleStudentCard.vue?vue&type=script&lang=js"

import "./SimpleStudentCard.vue?vue&type=style&index=0&id=5e3d7654&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3d7654"]])

export default __exports__